<template>
    <div class="inner">
        <div class="left">
            <div class="top">
                <div class="part">
                    <icon-title title="科技社团各成立时间段占比" iconName="kjtchenglishijian"></icon-title>
                    <div class="chart" id="chart1"></div>
                </div>
                <div class="part">
                    <icon-title title="各国科技社团占比" iconName="kejituanzb"></icon-title>
                    <div class="chart" id="chart2"></div>
                </div>
                <div class="part">
                    <icon-title title="各学科科技社团占比" iconName="kjtzbxueke"></icon-title>
                    <div class="chart" id="chart3"></div>
                </div>
            </div>
            <div class="bottom">
                <div class="part map">
                    <icon-title title="世界主要科技社团分布" iconName="sjkejituan" class="lg"></icon-title>
                    <div class="chart" id="map"></div>
                </div>
            </div>
        </div>
        <div class="right">
            <div class="top">
                <icon-title title="组织力 - 发达国家与发展中国家分项指标均分" iconName="zuzhili" class="lg"></icon-title>
                <div class="chart" id="chart4"></div>
            </div>
            <div class="center">
                <div class="part">
                    <icon-title title="凝聚力 - 学科指标均分" iconName="ningjuli1"></icon-title>
                    <div class="chart" id="chart5"></div>
                </div>
                <div class="part">
                    <icon-title title="凝聚力- 各阶段社团分项指标均分" iconName="ningjuli2"></icon-title>
                    <div class="chart" id="chart6"></div>
                </div>
            </div>
            <div class="bottom">
                <div class="part">
                    <icon-title title="影响力 - 分项指标均分" iconName="yixiangli1"></icon-title>
                    <div class="chart" id="chart7"></div>
                </div>
                <div class="part">
                    <icon-title title="影响力 - 社交媒体粉丝数前 10 国家" iconName="yixiangli2"></icon-title>
                    <div class="chart" id="chart8"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import IconTitle from '@/components/icontitle';
    import {
        getServiceGroup,
        getOrganizationalPower,
        getCohesiveForce,
        getEffect,
        world
    } from "@/assets/scripts/api/xhqj";
    const mapLineColor = '#00ccff';
    const lineColor = '#2F46C1';
    const labelColor = '#B5C8FF';
    const pieColor = ['#FB058F', '#06C0FB', '#0078FF', '#344DD5', '#EF9412', '#30CF70'];
    const barColor = ['#FB058F', '#EF9412', '#30CF6F', '#06C0FB', '#2F46C1', '#30CF70'];
    const mapColor = ['#cbfdff', '#8fadff', '#6278ff', '#4858e7', '#3f4cc3', '#232a6f', '#1a2165'];

    const GRID = {
        left: '0',
        top: '11%',
        bottom: '13%',
        right: '0',
        containLabel: true
    };

    const scatter = {
        name: 'light',
        type: 'scatter',
        symbol: 'pin', //气泡
        label: {
            normal: {
                formatter: '{@[2]}',
                show: true,
                textStyle: {
                    color: '#fff',
                    fontSize: 16
                }
            }
        },
        tooltip: {
            formatter: (params) => {
                return `${params.data.name}:${params.data.value[2]}`;
            }
        },
        itemStyle: {
            normal: {
                color: mapLineColor, //标志颜色
            },
            shadowBlur: 10,
            color: mapLineColor,
            shadowColor: mapLineColor,
            backgroundColor: mapLineColor,
        },
        hoverAnimation: true,
        isAxislabel: false
    };

    export default {
        name: 'ShiJieKeJieSheTuan',
        components: {
            IconTitle
        },
        data(){
            return {
                part8Data: {
                    column: ['美国', '英国', '德国', '日本', '中国', '加拿大', '比利时', '韩国', '澳大利亚', '伊比利亚'],
                    list: [1088498, 724554, 700696, 201131, 111872, 51811, 42970, 36634, 15365, 11270]
                },
            }
        },
        mounted(){
            this.init();
        },
        methods: {
            init(){

                getServiceGroup().then(({data}) => {
                    this.initPieChart(data);
                })

                getCohesiveForce().then(({data}) => {
                    this.initChart5(data.subject);
                    this.initChart6(data.society);
                })

                getEffect().then(({data}) => {
                    this.initChart7(data);
                })

                getOrganizationalPower().then(({data}) => {
                    this.initChart4(data);
                })

                world().then(({data}) => {
                    this.initWorldMapChart(data);
                })

                this.initChart8();
            },
            initPieChart(data){
                let chart1 = echarts.init(document.getElementById('chart1')),
                    option = this.getPieOption(data.time),
                    chart2 = echarts.init(document.getElementById('chart2')),
                    option2 = this.getPieOption(data.international),
                    chart3 = echarts.init(document.getElementById('chart3')),
                    option3 = this.getPieOption(data.subject);

                chart1.setOption(option, true);
                chart1.resize();
                this.$winResize(chart1.resize);
                chart2.setOption(option2, true);
                chart2.resize();
                this.$winResize(chart2.resize);
                chart3.setOption(option3, true);
                chart3.resize();
                this.$winResize(chart3.resize);
            },
            initWorldMapChart(data){
                let map = echarts.init(document.getElementById('map')),
                    option = this.getMapOption(data);

                map.setOption(option, true);
                map.resize();
                this.$winResize(map.resize);
            },
            initChart4(data){
                let chart = echarts.init(document.getElementById('chart4')),
                    option = this.getBarOption(data, '4');

                chart.setOption(option, true);
                chart.resize();
                this.$winResize(chart.resize);
            },
            initChart5(data){
                let chart = echarts.init(document.getElementById('chart5')),
                    option = this.getBarOption(data, '5');

                chart.setOption(option, true);
                chart.resize();
                this.$winResize(chart.resize);
            },
            initChart6(data){
                let chart = echarts.init(document.getElementById('chart6')),
                    option = this.getBarOption(data, '6');

                chart.setOption(option, true);
                chart.resize();
                this.$winResize(chart.resize);
            },
            initChart7(data){
                let chart = echarts.init(document.getElementById('chart7')),
                    option = this.getBarOption(data, '7');

                chart.setOption(option, true);
                chart.resize();
                this.$winResize(chart.resize);
            },
            initChart8(){
                let chart = echarts.init(document.getElementById('chart8')),
                    option = this.getBarOption(this.part8Data, '8');

                chart.setOption(option, true);
                chart.resize();
                this.$winResize(chart.resize);
            },
            getMapOption(data) {
                let valData = [];
                let mapData = data.map((item) => {

                    valData.push(item.list['数量'])
                    return {
                        value: item.list['数量'],
                        name: item.name
                    };
                });

                return {
                    tooltip: {
                        triggerOn: "mousemove",
                        formatter: function (params) {
                            if (params.name !== '') {
                                var a = '<span>' + params.name + '</span>';
                                var b = '<span>' + params.value + '</span>';
                                return [a, b].join(' :  ');
                            }
                        },
                        backgroundColor: 'rgba(29, 38, 71)',
                    },
                    geo: {
                        show: true,
                        map: 'world',
                        zoom: 1.2,
                        label: {
                            normal: {
                                show: false
                            },
                            emphasis: {
                                show: false,
                            }
                        },
                        itemStyle: {
                            normal: {
                                borderWidth: 0
                            },
                            emphasis: {
                                areaColor: '#cbfdff'
                            }
                        },
                        nameMap: {
                            Afghanistan: '阿富汗',
                            Singapore: '新加坡',
                            Angola: '安哥拉',
                            Albania: '阿尔巴尼亚',
                            'United Arab Emirates': '阿联酋',
                            Argentina: '阿根廷',
                            Armenia: '亚美尼亚',
                            'French Southern and Antarctic Lands': '法属南半球和南极领地',
                            Australia: '澳大利亚',
                            Austria: '奥地利',
                            Azerbaijan: '阿塞拜疆',
                            Burundi: '布隆迪',
                            Belgium: '比利时',
                            Benin: '贝宁',
                            'Burkina Faso': '布基纳法索',
                            Bangladesh: '孟加拉国',
                            Bulgaria: '保加利亚',
                            'The Bahamas': '巴哈马',
                            'Bosnia and Herzegovina': '波斯尼亚和黑塞哥维那',
                            Belarus: '白俄罗斯',
                            Belize: '伯利兹',
                            Bermuda: '百慕大',
                            Bolivia: '玻利维亚',
                            Brazil: '巴西',
                            Brunei: '文莱',
                            Bhutan: '不丹',
                            Botswana: '博茨瓦纳',
                            'Central African Republic': '中非共和国',
                            Canada: '加拿大',
                            Switzerland: '瑞士',
                            Chile: '智利',
                            China: '中国',
                            'Ivory Coast': '象牙海岸',
                            Cameroon: '喀麦隆',
                            'Democratic Republic of the Congo': '刚果民主共和国',
                            'Republic of the Congo': '刚果共和国',
                            Colombia: '哥伦比亚',
                            'Costa Rica': '哥斯达黎加',
                            Cuba: '古巴',
                            'Northern Cyprus': '北塞浦路斯',
                            Cyprus: '塞浦路斯',
                            'Czech Republic': '捷克共和国',
                            Germany: '德国',
                            Djibouti: '吉布提',
                            Denmark: '丹麦',
                            'Dominican Republic': '多明尼加共和国',
                            Algeria: '阿尔及利亚',
                            Ecuador: '厄瓜多尔',
                            Egypt: '埃及',
                            Eritrea: '厄立特里亚',
                            Spain: '西班牙',
                            Estonia: '爱沙尼亚',
                            Ethiopia: '埃塞俄比亚',
                            Finland: '芬兰',
                            Fiji: '斐',
                            'Falkland Islands': '福克兰群岛',
                            France: '法国',
                            Gabon: '加蓬',
                            'United Kingdom': '英国',
                            Georgia: '格鲁吉亚',
                            Ghana: '加纳',
                            Guinea: '几内亚',
                            Gambia: '冈比亚',
                            'Guinea Bissau': '几内亚比绍',
                            Greece: '希腊',
                            Greenland: '格陵兰',
                            Guatemala: '危地马拉',
                            'French Guiana': '法属圭亚那',
                            Guyana: '圭亚那',
                            Honduras: '洪都拉斯',
                            Croatia: '克罗地亚',
                            Haiti: '海地',
                            Hungary: '匈牙利',
                            Indonesia: '印度尼西亚',
                            India: '印度',
                            Ireland: '爱尔兰',
                            Iran: '伊朗',
                            Iraq: '伊拉克',
                            Iceland: '冰岛',
                            Israel: '以色列',
                            Italy: '意大利',
                            Jamaica: '牙买加',
                            Jordan: '约旦',
                            Japan: '日本',
                            Kazakhstan: '哈萨克斯坦',
                            Kenya: '肯尼亚',
                            Kyrgyzstan: '吉尔吉斯斯坦',
                            Cambodia: '柬埔寨',
                            Kosovo: '科索沃',
                            Kuwait: '科威特',
                            Laos: '老挝',
                            Lebanon: '黎巴嫩',
                            Liberia: '利比里亚',
                            Libya: '利比亚',
                            'Sri Lanka': '斯里兰卡',
                            Lesotho: '莱索托',
                            Lithuania: '立陶宛',
                            Luxembourg: '卢森堡',
                            Latvia: '拉脱维亚',
                            Morocco: '摩洛哥',
                            Moldova: '摩尔多瓦',
                            Madagascar: '马达加斯加',
                            Mexico: '墨西哥',
                            Macedonia: '马其顿',
                            Mali: '马里',
                            Myanmar: '缅甸',
                            Montenegro: '黑山',
                            Mongolia: '蒙古',
                            Mozambique: '莫桑比克',
                            Mauritania: '毛里塔尼亚',
                            Malawi: '马拉维',
                            Malaysia: '马来西亚',
                            Namibia: '纳米比亚',
                            'New Caledonia': '新喀里多尼亚',
                            Niger: '尼日尔',
                            Nigeria: '尼日利亚',
                            Nicaragua: '尼加拉瓜',
                            Netherlands: '荷兰',
                            Norway: '挪威',
                            Nepal: '尼泊尔',
                            'New Zealand': '新西兰',
                            Oman: '阿曼',
                            Pakistan: '巴基斯坦',
                            Panama: '巴拿马',
                            Peru: '秘鲁',
                            Philippines: '菲律宾',
                            'Papua New Guinea': '巴布亚新几内亚',
                            Poland: '波兰',
                            'Puerto Rico': '波多黎各',
                            'North Korea': '北朝鲜',
                            Portugal: '葡萄牙',
                            Paraguay: '巴拉圭',
                            Qatar: '卡塔尔',
                            Romania: '罗马尼亚',
                            Russia: '俄罗斯',
                            Rwanda: '卢旺达',
                            'Western Sahara': '西撒哈拉',
                            'Saudi Arabia': '沙特阿拉伯',
                            Sudan: '苏丹',
                            'South Sudan': '南苏丹',
                            Senegal: '塞内加尔',
                            'Solomon Islands': '所罗门群岛',
                            'Sierra Leone': '塞拉利昂',
                            'El Salvador': '萨尔瓦多',
                            Somaliland: '索马里兰',
                            Somalia: '索马里',
                            'Republic of Serbia': '塞尔维亚',
                            Suriname: '苏里南',
                            Slovakia: '斯洛伐克',
                            Slovenia: '斯洛文尼亚',
                            Sweden: '瑞典',
                            Swaziland: '斯威士兰',
                            Syria: '叙利亚',
                            Chad: '乍得',
                            Togo: '多哥',
                            Thailand: '泰国',
                            Tajikistan: '塔吉克斯坦',
                            Turkmenistan: '土库曼斯坦',
                            'East Timor': '东帝汶',
                            'Trinidad and Tobago': '特里尼达和多巴哥',
                            Tunisia: '突尼斯',
                            Turkey: '土耳其',
                            Uganda: '乌干达',
                            Ukraine: '乌克兰',
                            Uruguay: '乌拉圭',
                            'United States': '美国',
                            Uzbekistan: '乌兹别克斯坦',
                            Venezuela: '委内瑞拉',
                            Vietnam: '越南',
                            Vanuatu: '瓦努阿图',
                            'West Bank': '西岸',
                            Yemen: '也门',
                            'South Africa': '南非',
                            Zambia: '赞比亚',
                            Korea: '韩国',
                            Tanzania: '坦桑尼亚',
                            Zimbabwe: '津巴布韦',
                            Congo: '刚果',
                            'Central African Rep.': '中非',
                            Serbia: '塞尔维亚',
                            'Bosnia and Herz.': '波黑',
                            'Czech Rep.': '捷克',
                            'W. Sahara': '西撒哈拉',
                            'Lao PDR': '老挝',
                            'Dem.Rep.Korea': '朝鲜',
                            'Falkland Is.': '福克兰群岛',
                            'Timor-Leste': '东帝汶',
                            'Solomon Is.': '所罗门群岛',
                            Palestine: '巴勒斯坦',
                            'N. Cyprus': '北塞浦路斯',
                            Aland: '奥兰群岛',
                            'Fr. S. Antarctic Lands': '法属南半球和南极陆地',
                            Mauritius: '毛里求斯',
                            Comoros: '科摩罗',
                            'Eq. Guinea': '赤道几内亚',
                            'Guinea-Bissau': '几内亚比绍',
                            'Dominican Rep.': '多米尼加',
                            'Saint Lucia': '圣卢西亚',
                            Dominica: '多米尼克',
                            'Antigua and Barb.': '安提瓜和巴布达',
                            'U.S. Virgin Is.': '美国原始岛屿',
                            Montserrat: '蒙塞拉特',
                            Grenada: '格林纳达',
                            Barbados: '巴巴多斯',
                            Samoa: '萨摩亚',
                            Bahamas: '巴哈马',
                            'Cayman Is.': '开曼群岛',
                            'Faeroe Is.': '法罗群岛',
                            'IsIe of Man': '马恩岛',
                            Malta: '马耳他共和国',
                            Jersey: '泽西',
                            'Cape Verde': '佛得角共和国',
                            'Turks and Caicos Is.': '特克斯和凯科斯群岛',
                            'St. Vin. and Gren.': '圣文森特和格林纳丁斯'
                        }
                    },
                    visualMap: {
                        min: 0,
                        max: Math.max.apply(null, valData),
                        show: false,
                        seriesIndex: [0],
                        inRange: {
                            color: mapColor
                        }
                    },
                    series: [
                        {
                            type: 'map',
                            geoIndex: 0,
                            data: mapData
                        },
                        Object.assign({
                            coordinateSystem: 'geo',
                            data: this.convertData(data.slice(0, 6)),
                            symbolSize: 60,
                            zlevel: 2
                        },scatter),
                        Object.assign({
                            coordinateSystem: 'geo',
                            data: this.convertData(data.slice(6, 10)),
                            symbolSize: 40,
                            zlevel: 1
                        },scatter)
                    ]
                };
            },
            convertData(data) {
                let res = [];

                data.forEach((item) => {
                    let value = [];

                    value.push(item.lon);
                    value.push(item.lat);

                    for (let i in item.list) {

                        if (item.list.学会数 == 0) {
                            value = [];
                        } else {
                            value.push(item.list[i]);
                        }
                    }

                    res.push({
                        name: item.name,
                        value: value
                    });
                });

                return res;
            },
            getPieOption(data){
                return {
                    color: pieColor,
                    tooltip: {
                        trigger: 'item',
                        formatter: "{b} : {c} ({d}%)"
                    },
                    series: [{
                        type: 'pie',
                        center: ['50%', '50%'],
                        radius: [0, '75%'],
                        label: {
                            show: false
                        },
                        data: data
                    }]
                };
            },
            getBarOption(data, type) {
                let option,
                    color = [],
                    barWidth = 20,
                    seriesData = [],
                    lengendData = [];

                switch (type) {
                case '4':
                    barWidth = 60;
                    color = ['#06C0FB', '#2F46C1'];
                    break;
                case '5':
                    barWidth = 10;
                    color = barColor;
                    break;
                case '6':
                    barWidth = '40%';
                    color = ['#30CF6F', '#4256D4'];
                    break;
                case '7':
                    color = ['#06C0FB', '#EF9412'];
                    break;
                case '8':
                    seriesData.push({
                        type: 'bar',
                        barWidth: barWidth,
                        barGap: '10%',
                        itemStyle: {
                            normal: {
                                show: true,
                                color: '#06C0FB'
                            }
                        },
                        data: data.list
                    });

                    break;
                }

                if (type !== '8') {
                    this.isAxislabel = false;
                    data.list.forEach((item, index) => {

                        seriesData.push({
                            type: 'bar',
                            barWidth: barWidth,
                            barGap: '10%',
                            name: data.title[index],
                            itemStyle: {
                                normal: {
                                    show: true,
                                    color: color[index]
                                }
                            },
                            data: item
                        });

                        lengendData.push({
                            name: data.title[index],
                            icon: 'rect',
                            textStyle: {
                                color: labelColor,
                                margin: 7
                            }
                        })
                    });
                }else {
                    this.isAxislabel = true;
                }

                option = {
                    tooltip: {
                        trigger: 'axis',
                    },
                    legend: {
                        align: 'left',
                        position: 'center',
                        itemWidth: 12,
                        itemHeight: 12,
                        bottom: '0',
                        padding:[0 ,0],
                        itemGap: 5,
                        data: lengendData
                    },
                    grid: Object.assign(GRID,{
                        bottom:  type == 5?'20%':'15%'
                    }),
                    xAxis: {
                        type: 'category',
                        axisLabel: {
                            show: this.isAxislabel
                        },
                        axisLine: {
                            lineStyle: {
                                color: lineColor
                            }
                        },
                        axisTick: {
                            show: false,
                        },
                        data: data.column
                    },
                    yAxis: {
                        axisTick: {
                            show: false
                        },
                        axisLine: {
                            show: false
                        },
                        splitLine: {
                            show: true,
                            lineStyle: {
                                color: lineColor,
                                type: 'dotted'
                            }
                        },
                        axisLabel: {
                            show: true,
                            textStyle: {
                                color: labelColor,
                                fontSize: 12
                            },
                            formatter: '{value}'
                        }
                    },
                    series: seriesData
                };

                return option;
            }

        }
    }
</script>
<style lang="scss" scoped>
    @import "~@/assets/scss/mixins/_mixins.scss";

    $borderColor: #17215F;
    $borderDrakColor: #080B26;

    .inner {
        padding: 0% 2.08%;
        /*margin-top: -.52%;*/

        ::v-deep.title-line-main {
            margin-right: 0 !important;
        }

        .chart {
            width: 100%;
            height: calc(100% - 34px);
        }

        .left {
            float: left;
            width: 49.184%;
            height: 96.04%;

            .top {
                height: 36.7%;
                padding-top: 3.09%;

                .part {
                    float: left;
                    width: 29.06%;
                    height: 100%;
                    margin-right: 3.31%;

                    &:last-child {
                        float: right;
                    }

                    &:first-child {

                        .chart {
                            padding: {
                                top: 6.1%;
                                bottom: 8.45%;
                            }
                            background: url('~@/assets/images/piebg1.png') no-repeat center center / 100% auto;
                        }
                    }
                }

                .chart {
                    padding: 9.46% 6.1% 11.48%;
                    background: url('~@/assets/images/piebg2.png') no-repeat center center / 89% auto;
                }

            }

            .bottom {
                height: 63.3%;

                .part {
                    width: 96.46%;
                    height: 100%;
                    position: relative;
                    background: url('~@/assets/images/mapbg.png') no-repeat .4rem 34px / auto 18.8%;

                    &:after {
                        display: inline-block;
                        content: '';
                        width: 73.77%;
                        height: 10.26%;
                        background: url('~@/assets/images/mapline.png') no-repeat center center / 100% 100%;
                        @include position(absolute, 86.48%, auto, auto, 50%);
                        transform: translateX(-50%);
                    }

                    .chart {
                        padding: 0 2.86%;
                    }
                }
            }
        }

        .right {
            width: 50.815%;
            height: 96.04%;
            float: right;
            background: rgba(8, 11, 38, 0.5);
            border: 1px solid rgba(35, 51, 136, 1);
            box-shadow: 0px 0px 150px 0px rgba(39, 58, 159, 0.5);

            .top {
                height: 35.36%;
                padding: 3.21% 3.1% 1.21%;
            }

            .center {
                height: 32.27%;
                padding: 0 3.1% 1.21%;

                .part {
                    float: left;
                    width: 48%;
                    height: 100%;

                    &:last-child {
                        float: right;
                    }
                }
            }

            .bottom {
                @extend .center;
            }

        }
    }

</style>